<div class="min-h-screen flex flex-col bg-dc-navy pt-16 lg:pt-0">
  <app-header (menuClick)="onHeaderMenuClick()"></app-header>

  <div class="flex flex-1">
    <app-sidebar [open]="sidebarOpen" (close)="onSidebarClose()">></app-sidebar>
    <main class="flex-1 bg-gray-100">
      <!-- Breadcrumb -->
      <app-breadcrumb></app-breadcrumb>
      <div class="p-2 lg:pl-6 lg:pr-6 lg:pt-1">
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>
  <!-- <app-footer></app-footer> -->
</div>
